<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="align-left">
            <small class="text-muted">Invoice</small>
        </h3>
        <div class="dropdown-divider"></div><br />
        <app-modal :elements="modalElements" v-on:confirm="deleteInvoice"></app-modal>
        <app-data-search v-on:searching="search"></app-data-search>
        <button type="button" class="btn btn-outline-info" @click="edit">Edit <i class="far fa-edit"></i></button>
        <button type="button" class="btn btn-outline-success" @click="preview" style="margin-left: 20px;">Preview <i class="fas fa-print"></i></button>
        <div style="float:right;">
            <button type="button" class="btn btn-outline-danger" data-toggle="modal" :data-target="`#${modalElements.modalId}`">Delete<i class="far fa-trash-alt"></i></button>
        </div>
        <br /><br />
        <app-datatable :type="'view'" :elements="dtElements" :collections="invoice" v-on:selectedRow="selectRow"></app-datatable>
        <app-data-pagination v-on:pageChanged="changePage"></app-data-pagination>
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { Invoice } from '../../models/invoice'
import AppDatatable from '../../components/AppDatatable.vue'
import AppModal from '../../components/AppModal.vue'
import AppDataPagination from '../../components/AppDataPagination.vue'
import AppDataSearch from '../../components/AppDataSearch.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppDatatable, AppModal, AppDataPagination, AppDataSearch, AppNavBar
    },
    data() {
        return {
            invoice: [Invoice],
            modalElements: {
                modalId: 'invoice',
                title: 'Confirm',
                content: 'Are you sure to delete this Invoice?',
                type: 'text-confirm'
            },
            dtElements: [
                {
                    title: 'Patient Name',
                    column: 'patientName',
                    type: 'text'
                },
                {
                    title: 'Invoice No',
                    column: 'invoiceNo',
                    type: 'text'
                },
                {
                    title: 'Issued At',
                    column: 'date',
                    type: 'date'
                },
                {
                    title: 'Paid',
                    column: 'paid',
                    type: 'text'
                },
                {
                    title: 'Created At',
                    column: 'createdAt',
                    type: 'date'
                },
                {
                    title: 'Updated At',
                    column: 'updatedAt',
                    type: 'date'
                },
            ],
            selectedId: '',
            searchKey: '',
            pagination: {
                pageSize: 10,
                currentPage: 1
            }
        }
    },
    async created() {
        this.init()
    },
    methods: {
        async init() {
            const ivApi = api('invoice/partial')
            const query = {
                params: {
                    searchKey: this.searchKey,
                    currentPage: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize
                }
            }
            this.invoice = await ivApi.getWithQuery(query) 

        },
        add() {
            this.$router.push({ name: 'invoiceDetail' })
        },
        edit() {
            if(this.selectedId !== '') {
                this.$router.push({
                    name: 'invoiceDetail',
                    query: {
                        id: this.selectedId
                    }
                })
            }
        },
        async deleteInvoice() {
            if(this.selectedId !== '') {
                const ivApi = api('invoice/delete')
                await ivApi.delete(this.selectedId)
                this.init()
            }
        },
        selectRow(id) {
            this.selectedId = id
        },
        changePage(payload) {
            this.pagination = payload
            this.init()
        },
        search(searchKey) {
            this.searchKey = searchKey
            this.init()
        },
        async preview() {
            if(this.selectedId !== '') {
                this.$router.push({
                    name: 'invoiceReport',
                    query: {
                        id: this.selectedId
                    }
                })
            }
        },
    }
}
</script>